import { render } from "./UnassignedRatingCard.vue?vue&type=template&id=05070760"
import script from "./UnassignedRatingCard.vue?vue&type=script&lang=ts"
export * from "./UnassignedRatingCard.vue?vue&type=script&lang=ts"
script.render = render
/* custom blocks */
import block0 from "./UnassignedRatingCard.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


export default script